/**
 * Styles the block-based woocommerce/add-to-cart-with-options variation selector.
 *
 * Detects colour / size / generic attributes by reading the attribute label,
 * adds a classifier class to the pills container, and injects --swatch-bg CSS
 * variables so the CSS can paint colour circles without PHP involvement.
 */

const COLOR_MAP = {
	natural: '#F2EDE4',
	cream: '#EAE2D1',
	ivory: '#F5F0E8',
	white: '#FFFFFF',
	'off-white': '#F5F0E8',
	beige: '#E8DDD0',
	sand: '#E8DDC8',
	stone: '#D8D0BF',
	dust: '#D5C8B8',
	'warm-gold': '#C9A36A',
	gold: '#C9A36A',
	teal: '#1F3A47',
	'deep-teal': '#1F3A47',
	slate: '#7C8B9C',
	charcoal: '#3d4a56',
	ink: '#32373c',
	black: '#1a1815',
	navy: '#1a2a40',
	rust: '#A85A3C',
	terracotta: '#C06B52',
	sage: '#7D9B76',
	grey: '#9B9FA8',
	gray: '#9B9FA8',
	brown: '#8B6347',
	pink: '#E8A0A0',
	purple: '#7B5EA7',
	red: '#C06B52',
	blue: '#1a2a40',
	green: '#7D9B76',
	yellow: '#C9A36A',
	orange: '#C06B52',
};

function isLight( hex ) {
	const r = parseInt( hex.slice( 1, 3 ), 16 );
	const g = parseInt( hex.slice( 3, 5 ), 16 );
	const b = parseInt( hex.slice( 5, 7 ), 16 );
	return ( r * 299 + g * 587 + b * 114 ) / 1000 > 200;
}

export function initVariationSwatches() {
	const setup = () => {
		document
			.querySelectorAll(
				'[data-block-name="woocommerce/add-to-cart-with-options-variation-selector-attribute"]'
			)
			.forEach( ( attrEl ) => {
				const nameEl = attrEl.querySelector(
					'[data-block-name="woocommerce/add-to-cart-with-options-variation-selector-attribute-name"]'
				);
				const pillsEl = attrEl.querySelector(
					'.wc-block-add-to-cart-with-options-variation-selector-attribute-options__pills'
				);
				if ( ! nameEl || ! pillsEl ) {
					return;
				}

				const name = nameEl.textContent.trim().toLowerCase();

				if ( name.includes( 'color' ) || name.includes( 'colour' ) ) {
					pillsEl.classList.add( 'pdp-attr--color' );
					pillsEl
						.querySelectorAll(
							'label.wc-block-add-to-cart-with-options-variation-selector-attribute-options__pill'
						)
						.forEach( ( label ) => {
							const input = label.querySelector(
								'input[type="radio"]'
							);
							if ( ! input ) {
								return;
							}
							const key = input.value
								.toLowerCase()
								.replace( /[\s_]+/g, '-' );
							const bg = COLOR_MAP[ key ] ?? '#e5dfd3';
							label.style.setProperty( '--swatch-bg', bg );
							if ( isLight( bg ) ) {
								label.classList.add( 'swatch-is-light' );
							}
						} );
				} else if ( name.includes( 'size' ) ) {
					pillsEl.classList.add( 'pdp-attr--size' );
				} else {
					pillsEl.classList.add( 'pdp-attr--pill' );
				}
			} );
	};

	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', setup );
	} else {
		setup();
	}
}
